import { BaseLayer } from "./BaseLayer";

export class TsrLocationsLayer extends BaseLayer {
  constructor(map, apiUrl, exportUrl, csrfToken) {
    super(map, apiUrl, exportUrl, csrfToken);
    this.toggleButton = document.getElementById("button-map-tsr");
    this.markerTitle = "TSR Location";
    this.layerName = "TsrLocationsLaye";
    this.exportName = "TSR Locations";
    this.create();
  }

  showInfoWindow(event) {
    const feature = event.feature;

    let certificationLevels =
      feature.getProperty("certification_levels") === undefined ? "N/A" : feature.getProperty("certification_levels");

    const label = certificationLevels.length > 1 ? "Security Levels: " : "Security Level: ";

    const listItems = [
      '<i class="fa-li fa fa-globe-europe"></i> Location: ' + feature.getProperty("location"),
      '<i class="fa-li fa fa-file"></i> ' + label + certificationLevels.join(", "),
    ];

    this.createInfoWindow(listItems, event);
  }
}
